import axios, { AxiosResponse } from 'axios';

import RegisterNewInstrumentRequest from 'modules/Instruments/models/RegisterNewInstrumentRequest';

export default function registerNewInstrumentAsync(apiUrl: string) {
  return function api<TResponse>(
    request: RegisterNewInstrumentRequest | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/instruments`,
          method: 'POST',
          data: request,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
